<script setup lang="ts">
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { markSigningCompleteObserved } from '@Services/signingCompletionGate';

const route = useRoute();
const router = useRouter();

// DocuSign redirects to this view with ?event=... when signing completes.
// On iOS the top window may navigate here instead of the iframe, so we must
// redirect to the correct outcome route (complete/decline/finish-later).
onMounted(() => {

    const rawEvent = route.query.event;
    const event = (Array.isArray(rawEvent) ? rawEvent[0] : rawEvent)?.toLowerCase();
    if (event === 'signing_complete') {

        markSigningCompleteObserved();
    }

    const target =
        event === 'signing_complete'
            ? { name: 'complete' as const }
            : event === 'decline'
              ? { name: 'decline' as const }
              : event === 'viewing_complete' || event === 'cancel'
                ? { name: 'finish-later' as const }
                : null;

    if (target) {
        router.replace(target);
    }
});
</script>

<template>
    <div class="loading-container">
        <app-page-loader />
    </div>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.loading-container {
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
}
</style>
